import type { ExplicitAddress } from '@cronos-app/sdk';
import { currentWallet } from '@cronos-app/wallet';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSDK } from '@ui/utils';
import type { Fraction } from 'bi-fraction';

import { useAgents } from '../api/useAgents';
import { getTokenBalanceQueryKey } from '../contracts/useTokenBalance';

export const useAgentTokenLaunch = (
  onSuccess?: (result: {
    hash?: string;
    tokenAddress?: ExplicitAddress;
  }) => void,
) => {
  const sdk = useSDK();
  const queryClient = useQueryClient();
  const provider = currentWallet.useProvider();

  return useMutation(
    async ({
      name,
      ticker,
      description,
      image,
      urls,
      purchaseAmount,
    }: {
      name: string;
      ticker: string;
      // cores: number[];
      description: string;
      image: string;
      urls: [string, string, string, string];
      purchaseAmount: Fraction;
    }) => {
      const signer = await provider?.getSigner();
      if (!signer) throw new Error('no signer');
      const agentLauncherModule = sdk.getAgentLauncher(signer);
      const result = await agentLauncherModule.launchToken(
        name,
        ticker,
        description,
        image,
        urls,
        purchaseAmount,
      );

      return { hash: result.receipt?.hash, tokenAddress: result.tokenAddress };
    },
    {
      onSuccess: (result) => {
        queryClient.invalidateQueries({
          queryKey: getTokenBalanceQueryKey(sdk.getContractAddress('AgentFun')),
        });
        queryClient.invalidateQueries({
          queryKey: [useAgents.queryKey],
        });
        onSuccess?.(result);
      },
    },
  );
};
